module.exports = __webpack_public_path__ + "img/es-active.a7c5da44.png";